// extracted by mini-css-extract-plugin
export default {"cell":"_1IZtG","content":"_14I9E","today":"_22rW4","active":"_1WNFY","border":"_10XXq","withEvents":"RFZff","day":"_23Smx","otherMonth":"_2RItO"};